
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import MatchinPayHistory from "@/components/matchinpay/MatchinPayHistory.vue";
import { getCurrentUser } from '../../utils/index';
import { ecShopAdvisoryVisibility } from "@/api/common";


export default defineComponent({
  name: "matchinpayhistory",
  components: {
    MatchinPayHistory
  },
  data(){
    return {
      pt : "",
      ccode : -1,
      current_usid: "" as string,
      mgpaybalance : 0.00
    }
  },
  methods : {
    hideECShopAdvisory(){
      ecShopAdvisoryVisibility.hide();
    },
    showECShopAdvisory(){
      ecShopAdvisoryVisibility.show();
    }
  },
  setup() {
    const tabIndex = ref(0);
    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("onlineShopTab") || "0");

      setCurrentPageTitle("MG Pay");
    });
  },
  mounted(){
    let user = getCurrentUser(); 
    
    if(user !== undefined){
        this.current_usid = user.usid ;
    }
    this.ccode = Number(localStorage.getItem("ccode"));
    this.pt = String(localStorage.getItem("pt"));
    
    this.hideECShopAdvisory();
  },
  unmounted(){
    this.showECShopAdvisory();
  }
});
